import axios from 'axios'
import Validator from '@/modules/validator.module.js'
import Response from '@/modules/response.module.js'
import { getAuthToken } from "@/utils/user.utils";
import { csrfToken } from "@/utils/global.utils";
import links from '@/constants/links';
import blacklist from "@/constants/blacklist"
import {
    app
} from '@/app'

axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
};

const instance = axios.create()

const ValidatorModule = new Validator();
const ResponseModule = new Response();


// Add request interceptors
instance.interceptors.request.use((config) => {
    // Do something before request is sent
    // const apiToken = sessionStorage.getItem('token')
    // config.headers = { 'Custom-Header-IF-Exist': apiToken }

    if (config.url.includes(process.env.MIX_APP_URL)) {
        config.headers.common['X-XSRF-TOKEN'] = csrfToken()
    }
    // Clear msgs
    ValidatorModule.clear();

    let token = getAuthToken()
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
}, error => {
    return Promise.reject(error)
})

// Add a response interceptor
instance.interceptors.response.use(
    response => response,
    error => {
        let payload = [];
        if (error && error.response && error.response.status === 401) {
            app.then(({
                $router
            }) => {
                if (blacklist.routes.logged.includes(window.location.pathname)) {
                    $router.push({
                        path: links.routes.login
                    });
                }
            });
            // This error is only for when username and pass not set
        } else if (error && error.response && error.response.status === 424) {
            app.then(({
                $router
            }) => {
                $router.push({
                    path: links.routes.profileOAuthSetup
                });
            });
        } else if (error && error.response && error.response.status === 419) {
            console.error('Invalid CSRF TOKEN');
            // Handle validator errors
            ValidatorModule.add('csrfToken', {
                type: 0,
                msg: "Something went wrong, please refresh and try again."
            })
        } else if (error && error.response && error.response.status === 422) {
            if (error.response.data.errors) {
                for (let key in error.response.data.errors) {
                    // if the error is type of array, than is an error from laravel validator
                    // and custom error of ours
                    if (Array.isArray(error.response.data.errors[key])) {
                        for (let index in error.response.data.errors[key]) {
                            const newKey = `${key}-${index}`;
                            payload.push(
                                // Handle validator errors
                                ValidatorModule.add(newKey, {
                                    type: 0,
                                    msg: error.response.data.errors[key][index]
                                })
                            );
                        }
                        // else if not array just push it in as object
                    } else {
                        payload.push(
                            // Handle validator errors
                            ValidatorModule.add(key, error.response.data.errors[key])
                        );
                    }
                }
            }
        } else {
            payload.push(error);
        }
        // Response module
        return Promise.reject(ResponseModule.make(error.response.status, null, payload))
    })

export default instance
